module.exports = __webpack_public_path__ + "static/media/soup.fae03e97.png";